<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Назначенные компании
            </div>
            <div class="content-inner">
                <table>
                    <tr>
                        <td>ID компании</td>
                        <td>Компания</td>
                        <td></td>
                    </tr>
                    <tr v-for="company in companies" :key="company.company_id">
                        <td>{{ company.company_id }}</td>
                        <td>{{ company.company_name }}</td>
                        <td>
                            <button @click="delete_record(company.company_record_id)">Убрать из компании</button>
                        </td>
                    </tr>
                </table>
            </div>
            <br><br>
            <span>Добавить в компанию</span><br>
            <select v-model="new_company" style="width: 300px;">
                <option v-for="company in all_companies" :key="company.id" :value="company.id">{{ company.full_name }}</option>
            </select><br><br>
            <button @click="add_user_to_company()">Добавить</button>
        </div>
    </div>
</template>


<script>
export default {
    name: 'CompaniesForUser',
    props: ['id'],
    data() {
        return {
            companies: {},
            all_companies: {},
            new_company: 0
        }
    },
    methods: {
        get_companies_by_user() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/company_by_user/'+this.id)
            .then(response => {
                this.companies = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_all_companies() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/companies')
            .then(response => {
                this.all_companies = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        add_user_to_company() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/add_user_to_company/'+this.id+'/'+this.new_company)
            .then(response => {
                console.log(response.data.data)
                this.get_companies_by_user()  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        delete_record(company_record_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/delete_user_to_company/'+ company_record_id)
            .then(response => {
                console.log(response.data.data)
                this.get_companies_by_user()  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.get_companies_by_user()
        this.get_all_companies()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>